import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { QueryProvider } from "./providers/QueryProvider.tsx";
import { ScreenSizeProvider } from "./providers/ScreenSizeProvider.tsx";
import "./styles/base.scss";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <ScreenSizeProvider>
          <App />
        </ScreenSizeProvider>
      </QueryProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
